export default __webpack_public_path__ + "static/media/uploader-animas-4.256f1524.png";